import { ProductType } from '@features/products/enums/productType'
import { ProductUnit } from '@features/products/enums/productUnit'

import { DemoInvoiceProduct } from '../types/demoInvoiceProduct'

export const DEMO_INVOICE_PRODUCTS: DemoInvoiceProduct[] = [
  {
    id: 'demo-product-1',
    productType: ProductType.Services,
    tName: 'demo_invoice.fixtures.products.website_design',
    unit: ProductUnit.Forfait,
    unitPrice: 1200,
    vatRatePercent: 0.2,
  },
  {
    id: 'demo-product-2',
    productType: ProductType.Services,
    tName: 'demo_invoice.fixtures.products.consulting_hour',
    unit: ProductUnit.Hour,
    unitPrice: 90,
    vatRatePercent: 0.2,
  },
  {
    id: 'demo-product-3',
    productType: ProductType.Goods,
    tName: 'demo_invoice.fixtures.products.printed_flyers',
    unit: ProductUnit.Unit,
    unitPrice: 0.35,
    vatRatePercent: 0.2,
  },
  {
    id: 'demo-product-4',
    productType: ProductType.Goods,
    tName: 'demo_invoice.fixtures.products.book',
    unit: ProductUnit.Unit,
    unitPrice: 25,
    vatRatePercent: 0.055,
  },
]
